var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('DashboardHeader',{attrs:{"title":"Video Tutorials"}},[_c('div',{staticClass:"mx-10 mt-8"},[_c('VideoTiles',{attrs:{"videos":_vm.videos,"vidPath":"/videos/bitsems-video-tutorials/"}})],1)])],1)
}
var staticRenderFns = []

export { render, staticRenderFns }